
import Vue from "vue";
import Otp from "./partials/Otp.vue";
import msDataProvider from "@/services/msDataProvider";

export default Vue.extend({
  components: {
    Otp
  },
  data() {
    return {
      introductionOtp: false,
      totpCodeModal: false,
      code: '',
      loadingCopy: false,
      copied: false
    }
  },
  methods: {
    parseData(dataStr) {
      return JSON.parse(dataStr);
    },
    imageSrc(dataStr) {
      const qr = this.parseData(dataStr).qr;
      return `data:image/png;base64,${qr}`;
    },
    otpCode(dataStr) {
      try {
        const url = this.parseData(dataStr).url;
        return url.split('secret=')[1];
      } catch (e) {
        return "";
      }
    },
    async copyToClipboard(data) {
      this.loadingCopy = true;
      await navigator.clipboard.writeText(this.otpCode(data));
      this.copied = true;
      this.loadingCopy = false;
      setTimeout(() => {
        this.copied = false;
      }, 3000)
    },
    async goToTOTPSettingIntroduction() {
      try {
        await msDataProvider.executeCommand("extOpenUrl", {
          url: 'https://msuite.viettel.vn/user/help/index#7-h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-ng%C6%B0%E1%BB%9Di-d%C3%B9ng-c%C3%A0i-%C4%91%E1%BA%B7t-x%C3%A1c-th%E1%BB%B1c-totp-qua-%E1%BB%A9ng-d%E1%BB%A5ng-authenticator',
        });
      } catch (e) {
        console.log(e);
      }
    },

  }
});
